import React, { useState, useCallback, useRef } from "react";
// import { motion } from "framer-motion";
import logo from "../assets/lg.png";
import StepOne from "./steps/StepOne";
import CompleteSection from "./CompleteSection";
import StepTwo from "./steps/StepTwo";
import StepThree from "./steps/StepThree";
import FinishSection from "./FinishSection";
import register from "../registerApi";

export default function StepperForm() {
  const [step, setStep] = useState(1);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [data, setData] = useState({
    image: null,
    firstName: "",
    lastName: "",
    hobbies: [],
    industry: "",
    birthMonth: "",
    birthDay: "",
    views: "",
    phoneNumber: "",
    gender: "",
    email: "",
    package: "",
  });
  function handleInputChange(label, value) {
    setData((data) => ({ ...data, [label]: value }));
  }
  function handleAddHobby(val) {
    setData((data) => {
      let updatedHobbies = [...data.hobbies, val];
      return { ...data, hobbies: updatedHobbies };
    });
  }
  function handleRemoveHobby(val) {
    setData((data) => {
      let updatedHobbies = data.hobbies.filter((hb) => hb !== val);
      return { ...data, hobbies: updatedHobbies };
    });
  }
  function handleSelectCountry(val) {
    setSelectedCountry(val);
    // console.log("val");
  }

  const getClass = useCallback(
    (stepArea) => {
      if (stepArea === step) return "active";
      return "";
    },
    [step]
  );
  async function goNext() {
    // console.log(nextStep);
    let response = { ok: false };
    if (step === 1) {
      response = await stepOneRef.validateData();
    }
    if (step === 2) {
      response = await stepTwoRef.validateData();
    }
    if (!response.ok) return;
    setStep((step) => step + 1);
  }
  async function onGoStep(_) {
    // let response = { ok: false };
    // if (step === 1) {
    //   response = await stepOneRef.validateData();
    // }
    // if (stepto === 2) {
    //   response = await stepTwoRef.validateData();
    // }
    // if (!response.ok) return;
    // setStep((step) => step + 1);
  }
  async function onComplete() {
    // console.log(nextStep);
    let response = { ok: false };
    if (step === 3) {
      response = await stepThreeRef.validateData();
    }
    if (step === "complete") {
      handleFinish();
      // if (response.ok) {
      //   setStep("finish");
      // } else {
      // }
      return;
    }
    if (!response.ok) return;
    setErrorsFormSubmit([]);
    setStep("complete");
  }
  const stepOneRef = useRef(null);
  const stepTwoRef = useRef(null);
  const stepThreeRef = useRef(null);
  function handleGoToBirthday() {
    setStep(2);
    stepTwoRef.focusBirthday();
  }
  const [errorsFormSubmit, setErrorsFormSubmit] = useState([]);
  const [submitBtn, setSubmitBtn] = useState({
    text: "Register Me",
    loading: false,
  });
  async function handleFinish() {
    setErrorsFormSubmit([]);
    setSubmitBtn((submit) => ({
      ...submit,
      text: "Processing...",
      loading: true,
    }));
    const formData = new FormData();
    formData.append("firstName", data.firstName);
    formData.append("lastName", data.lastName);
    formData.append("hobbies", data.hobbies);
    formData.append("industry", data.industry);
    formData.append("birthMonth", data.birthMonth);
    formData.append("birthDay", data.birthDay);
    const formatedPhone = `${selectedCountry.value}${data.phoneNumber}`;
    formData.append("phoneNumber", formatedPhone);
    formData.append("gender", data.gender);
    formData.append("email", data.email);
    formData.append("package", data.package);
    const image = data.image && data.image.file ? data.image.file : null;
    if (image) {
      formData.append("image", image);
    }
    const response = await register(formData);
    setSubmitBtn((submit) => ({
      ...submit,
      text: "Register Me",
      loading: false,
    }));
    if (response.ok) {
      setStep("finish");
      setData({
        image: null,
        firstName: "",
        lastName: "",
        hobbies: [],
        industry: "",
        birthMonth: "",
        birthDay: "",
        views: "",
        phoneNumber: "",
        gender: "",
        email: "",
        package: "",
      });
    } else {
      if (response.status === 422) {
        const errorObject = response.data.errors;

        let errorsArray = [];
        Object.values(errorObject).forEach(
          (val) => (errorsArray = [...errorsArray, ...val])
        );
        setErrorsFormSubmit(errorsArray);
        // console.log("errors obj", errorsArray);
      } else {
        setErrorsFormSubmit([
          "Unable to submit currently, please come again later",
        ]);
      }
    }
  }
  function handleGoBack() {
    if (step === "complete") {
      setStep(3);
    } else {
      setStep((step) => step - 1);
    }
  }
  return (
    <>
      <div className="z-30 max-w-3xl mx-auto px-4 py-5 overflow-x-hidden">
        <div className="text-center">
          <div className="text-center flex justify-center items-center">
            <img src={logo} alt="Faniki Africa" className="w-10" />
          </div>
          <h2 className="text-theme text-xl  tracking-wider font-bold">
            Become a Member of Faniki
          </h2>
          <p className="text-secondaryTheme text-sm italic">
            It's as easy as hop, step and jump
          </p>
        </div>
        <div>
          <div className="mt-5">
            <ul id="progressbar">
              <li
                onClick={() => onGoStep(1)}
                className={`${getClass(1)}`}
                id="account"
              >
                <strong>Step 1</strong>
              </li>
              <li
                onClick={() => onGoStep(2)}
                className={`${getClass(2)}`}
                id="personal"
              >
                <strong>Step 2</strong>
              </li>
              <li
                onClick={() => onGoStep(3)}
                className={`${getClass(3)}`}
                id="payment"
              >
                <strong>Step 3</strong>
              </li>
            </ul>
          </div>
        </div>
        {step === "complete" && (
          <CompleteSection
            data={data}
            onGoToBirthday={handleGoToBirthday}
            selectedCountry={selectedCountry}
            setStep={setStep}
            errorsFormSubmit={errorsFormSubmit}
          />
        )}
        {step === "finish" && <FinishSection setStep={setStep} />}

        {step !== "complete" && step !== "finish" && (
          <div>
            <div>
              {step === 1 && (
                <StepOne
                  onInputChange={handleInputChange}
                  data={data}
                  selectedCountry={selectedCountry}
                  onSelectCountry={handleSelectCountry}
                  stepRef={stepOneRef}
                />
              )}
              {step === 2 && (
                <StepTwo
                  onInputChange={handleInputChange}
                  data={data}
                  selectedCountry={selectedCountry}
                  onSelectCountry={handleSelectCountry}
                  onAddHobby={handleAddHobby}
                  onRemoveHobby={handleRemoveHobby}
                  stepRef={stepTwoRef}
                />
              )}
              {step === 3 && (
                <StepThree
                  stepRef={stepThreeRef}
                  onGoToBirthday={handleGoToBirthday}
                  data={data}
                  onInputChange={handleInputChange}
                  selectedCountry={selectedCountry}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <div className="top-shadow  py-5 bg-white shadow-md">
        <div className="max-w-3xl mx-auto px-4">
          <div className="flex justify-between items-center">
            <div className="w-1/2">
              {step !== "finish" && (
                <button
                  disabled={step === 1}
                  onClick={handleGoBack}
                  className="disabled:cursor-not-allowed disabled:text-gray-400 w-32 focus:outline-none py-2 px-5 rounded-lg shadow-sm text-center text-gray-600 bg-white hover:bg-gray-100 font-medium border"
                >
                  Previous
                </button>
              )}
            </div>

            <div className="w-1/2 text-right">
              {step === 3 && (
                <button
                  onClick={onComplete}
                  className="w-32 focus:outline-none border border-transparent py-2 px-5 rounded-lg shadow-sm text-center text-white bg-blue-500 hover:bg-blue-600 font-medium"
                >
                  Complete
                </button>
              )}
              {step === "complete" && (
                <button
                  onClick={onComplete}
                  disabled={submitBtn.loading}
                  className="disabled:text-greyTwo disabled:cursor-not-allowed focus:outline-none border border-transparent py-2 px-5 rounded-lg shadow-sm text-center text-white bg-blue-500 hover:bg-blue-600 font-medium"
                >
                  {submitBtn.text}
                </button>
              )}

              {step < 3 && (
                <button
                  onClick={goNext}
                  className="focus:outline-none border border-transparent py-2 px-5 rounded-lg shadow-sm text-center text-white bg-blue-500 hover:bg-blue-600 font-medium"
                >
                  Next
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
